import React from 'react';

interface Props {
  title?: string;
  items: any[];
  show: boolean[]; // boolean array indicating which indices are visible
  renderItem: (item: any, idx: number) => JSX.Element;
  onAdd: (idx: number) => void; // called with current idx to reveal next
  showAddAt?: (idx: number) => boolean; // optional predicate to decide if "+ adicionar" appears at idx
}

export default function RepeatableBlock({ title, items, show, renderItem, onAdd, showAddAt }: Props) {
  return (
    <div style={{ marginBottom: 12 }}>
      {title && <div className="section-title">{title}</div>}
      {items.map((it, idx) => {
        if (!show[idx]) return null;
        return (
          <div key={idx} className="hidden-block" style={{ marginBottom: 12 }}>
            {renderItem(it, idx)}
            { (showAddAt ? showAddAt(idx) : idx + 1 < items.length) && (
              <div style={{ marginTop: 8 }}>
                <button className="btn btn-secondary" onClick={() => onAdd(idx)}>+ Adicionar</button>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
